export default __webpack_public_path__ + "static/logo-d082fdb557eaaa51b4f67ddc71d3745c.png";